export function delegatedHTTPRoutingDefaults() {
    return {
        filterProtocols: ['unknown', 'transport-bitswap', 'transport-ipfs-gateway-http'],
        filterAddrs: ['https', 'webtransport', 'webrtc', 'webrtc-direct', 'wss']
    };
}
//# sourceMappingURL=delegated-http-routing-defaults.browser.js.map